import { bluePrimary } from 'src/styles/colors';
import styled from 'styled-components';

export const CardBorderTop = styled.div`
  border-top: 8px solid ${bluePrimary};
`;
